var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "level" },
            [
              _c(
                "Header",
                _vm._b(
                  { staticClass: "level-left" },
                  "Header",
                  _vm.$route.meta,
                  false
                )
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Start Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "dateStart",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Start Date",
                        },
                        model: {
                          value: _vm.dateStart,
                          callback: function ($$v) {
                            _vm.dateStart = $$v
                          },
                          expression: "dateStart",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "End Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "dateEnd",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "End Date",
                        },
                        model: {
                          value: _vm.dateEnd,
                          callback: function ($$v) {
                            _vm.dateEnd = $$v
                          },
                          expression: "dateEnd",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.user.group.plants && _vm.user.group.plants.length != 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: { icon: "industry", expanded: "" },
                              model: {
                                value: _vm.selectedPlant,
                                callback: function ($$v) {
                                  _vm.selectedPlant = $$v
                                },
                                expression: "selectedPlant",
                              },
                            },
                            _vm._l(_vm.user.group.plants, function (plant) {
                              return _c(
                                "option",
                                { key: plant.id, domProps: { value: plant } },
                                [_vm._v(" " + _vm._s(plant.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c("multiselect", {
                            staticStyle: { "min-width": "400px" },
                            attrs: {
                              options: _vm.plants,
                              multiple: false,
                              "close-on-select": true,
                              placeholder: "Pick plant",
                              "custom-label": (obj) =>
                                obj.id + " - " + obj.name,
                              "track-by": "name",
                            },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          }),
                        ],
                        1
                      ),
                  _vm.forecasts.length > 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Types" } },
                        [
                          _c("multiselect", {
                            staticStyle: { "min-width": "400px" },
                            attrs: {
                              options: _vm.siteTypes,
                              multiple: true,
                              "close-on-select": false,
                              placeholder: "Pick Types to forecast",
                              "custom-label": (obj) => obj.name,
                              "track-by": "name",
                            },
                            model: {
                              value: _vm.selectedTypes,
                              callback: function ($$v) {
                                _vm.selectedTypes = $$v
                              },
                              expression: "selectedTypes",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right",
                          attrs: {
                            type: "is-warning",
                            "icon-left": "arrows-rotate",
                            disabled:
                              _vm.isLoading || _vm.selectedPlant === null,
                          },
                          on: {
                            click: () => {
                              _vm.resetData()
                              _vm.getData()
                            },
                          },
                        },
                        [_vm._v(" Load ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right ml-3",
                          attrs: {
                            type: "is-success",
                            "icon-left": "download",
                            disabled: !_vm.forecasts.length > 0,
                          },
                          on: {
                            click: () => {
                              _vm.exportToExcel()
                            },
                          },
                        },
                        [_vm._v(" Export xlsx ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right ml-3",
                          attrs: {
                            type: "is-success",
                            "icon-left": "upload",
                            disabled:
                              _vm.isLoading || !_vm.forecasts.length > 0,
                          },
                          on: {
                            click: () => {
                              _vm.isImportingExcel = true
                            },
                          },
                        },
                        [_vm._v(" Import xlsx ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "left-right ml-3",
                          attrs: {
                            type: "is-warning",
                            "icon-left": "x",
                            disabled: !_vm.forecasts.length > 0,
                          },
                          on: {
                            click: () => {
                              _vm.resetSimulations()
                            },
                          },
                        },
                        [_vm._v(" Reset Simulations ")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            "margin-right": "-10px",
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          _c(
                            "b-switch",
                            {
                              model: {
                                value: _vm.shipmentView,
                                callback: function ($$v) {
                                  _vm.shipmentView = $$v
                                },
                                expression: "shipmentView",
                              },
                            },
                            [_vm._v(" Shipment View ")]
                          ),
                          _c(
                            "b-switch",
                            {
                              staticStyle: { "margin-top": "5px" },
                              model: {
                                value: _vm.infoCard,
                                callback: function ($$v) {
                                  _vm.infoCard = $$v
                                },
                                expression: "infoCard",
                              },
                            },
                            [_vm._v(" Info Card ")]
                          ),
                          _c(
                            "b-switch",
                            {
                              staticStyle: { "margin-top": "5px" },
                              model: {
                                value: _vm.meanCard,
                                callback: function ($$v) {
                                  _vm.meanCard = $$v
                                },
                                expression: "meanCard",
                              },
                            },
                            [_vm._v(" Mean Card ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.undecidedCollsOut.length > 0 ||
                  _vm.undecidedCollsIn.length > 0
                    ? _c(
                        "b-field",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "left-right",
                              attrs: { type: "is-success", "icon-left": "box" },
                              on: {
                                click: () => {
                                  _vm.isCheckingUndecided = true
                                },
                              },
                            },
                            [_vm._v(" Undated Shipments ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.forecasts.length > 0
                    ? _c(
                        "b-field",
                        {
                          staticClass: "card px-2 py-2",
                          attrs: { label: "Max Stocks", grouped: "" },
                        },
                        [
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Max total: " + _vm.target.max_total) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Max Clean: " + _vm.target.max_clean) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.forecasts.length > 0
                    ? _c(
                        "b-field",
                        {
                          staticClass: "card px-2 py-2",
                          attrs: { label: "Safety Stocks", grouped: "" },
                        },
                        [
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Clean: " + _vm.target.min_clean) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Dirty: " + _vm.target.min_dirty) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  "Available: " + _vm.target.min_available
                                ) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Repair: " + _vm.target.min_repair) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.forecasts.length > 0 && _vm.infoCard
            ? _c(
                "div",
                {
                  staticClass: "card px-2 py-2",
                  staticStyle: {
                    width: "fit-content",
                    position: "fixed",
                    top: "85px",
                    right: "5px",
                    "z-index": "3",
                  },
                },
                [
                  _c("b-field", [
                    _vm._v(" " + _vm._s(_vm.selectedPlant.name) + " "),
                  ]),
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-switch",
                        {
                          model: {
                            value: _vm.shipmentView,
                            callback: function ($$v) {
                              _vm.shipmentView = $$v
                            },
                            expression: "shipmentView",
                          },
                        },
                        [_vm._v(" Shipment View ")]
                      ),
                    ],
                    1
                  ),
                  _vm.forecasts.length > 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Max Stocks", grouped: "" } },
                        [
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Max total: " + _vm.target.max_total) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Max Clean: " + _vm.target.max_clean) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.forecasts.length > 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Safety Stocks", grouped: "" } },
                        [
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Clean: " + _vm.target.min_clean) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Dirty: " + _vm.target.min_dirty) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  "Available: " + _vm.target.min_available
                                ) +
                                " "
                            ),
                          ]),
                          _c("b-field", [
                            _vm._v(
                              " " +
                                _vm._s("Repair: " + _vm.target.min_repair) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("b-button", {
                    staticClass: "left-right mr-2",
                    style: {
                      display: "block",
                      position: "absolute",
                      top: "0",
                      right: "0",
                    },
                    attrs: { type: "is-ghost", "icon-left": "x" },
                    on: {
                      click: () => {
                        _vm.closeInfoCard()
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.meanCard
            ? _c(
                "div",
                {
                  staticClass: "card px-2 py-2",
                  staticStyle: {
                    width: "fit-content",
                    position: "fixed",
                    top: "325px",
                    right: "5px",
                    "z-index": "3",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        "margin-right": "10px",
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-switch",
                            {
                              model: {
                                value: _vm.collectMeanCounts,
                                callback: function ($$v) {
                                  _vm.collectMeanCounts = $$v
                                },
                                expression: "collectMeanCounts",
                              },
                            },
                            [_vm._v(" Collect Mean ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-switch",
                            {
                              model: {
                                value: _vm.washingMeanCounts,
                                callback: function ($$v) {
                                  _vm.washingMeanCounts = $$v
                                },
                                expression: "washingMeanCounts",
                              },
                            },
                            [_vm._v(" Washing Mean ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        [
                          _c(
                            "b-switch",
                            {
                              model: {
                                value: _vm.repairMeanCounts,
                                callback: function ($$v) {
                                  _vm.repairMeanCounts = $$v
                                },
                                expression: "repairMeanCounts",
                              },
                            },
                            [_vm._v(" Repair Mean ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-button", {
                    staticClass: "left-right mr-2",
                    style: {
                      display: "block",
                      position: "absolute",
                      top: "0",
                      right: "0",
                    },
                    attrs: { type: "is-ghost", "icon-left": "x" },
                    on: {
                      click: () => {
                        _vm.closeMeanCard()
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.forecasts, function (forecast, index) {
            return _c(
              "div",
              {
                key: forecast.date,
                staticClass: "card pl-2 py-1",
                style: {
                  "margin-top": "2rem",
                  "padding-right": "0.75rem",
                  "background-color": forecast.inventory
                    ? "rgb(252, 252, 149)"
                    : _vm.holidays.includes(
                        new Date(forecast.date).toLocaleDateString("en-CA")
                      )
                    ? "rgb(50, 50, 50)"
                    : "",
                  border: "2px solid transparent",
                  "border-image-slice": "1",
                  "border-image":
                    "linear-gradient(to left, rgb(125, 125, 125), rgb(225, 225, 225)) 3",
                  color: _vm.holidays.includes(
                    new Date(forecast.date).toLocaleDateString("en-CA")
                  )
                    ? "rgb(255, 255, 255)"
                    : "black",
                },
              },
              [
                _c("div", { style: { "text-transform": "capitalize" } }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        new Date(forecast.date).toLocaleDateString("en-EN", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      ) +
                      " "
                  ),
                ]),
                !_vm.shipmentView
                  ? _c(
                      "div",
                      { staticClass: "columns" },
                      [
                        _vm._l(_vm.selectedTypes, function (type) {
                          return _c(
                            "div",
                            { key: type.name, staticClass: "column" },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "border-bottom":
                                      "1px rgb(100, 100, 100) solid",
                                    "padding-left": "0.3rem",
                                  },
                                },
                                [_vm._v(" " + _vm._s(type.name) + " ")]
                              ),
                              _vm._l(forecast.statuses, function (status) {
                                return _c(
                                  "div",
                                  {
                                    key: status,
                                    staticStyle: {
                                      "background-color":
                                        "rgba(245, 222, 179, 0.8)",
                                      "padding-left": "0.3rem",
                                      color: "black",
                                    },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(status) + " "),
                                    _c(
                                      "span",
                                      {
                                        style:
                                          forecast.values[type.name][status]
                                            .num_crates >= 0
                                            ? forecast.values[type.name][status]
                                                .changed
                                              ? { color: "blue" }
                                              : {}
                                            : { color: "red" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              forecast.values[type.name][
                                                status
                                              ].num_crates.toFixed(0)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              _c(
                                "div",
                                {
                                  style: {
                                    "border-top":
                                      "1px rgb(190, 190, 190) solid",
                                    "background-color":
                                      "rgba(190, 230, 250, 1)",
                                    "padding-left": "0.3rem",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(" Washed "),
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: forecast.washed[type.name]
                                          ? "black"
                                          : _vm.simulations[
                                              forecast.date +
                                                "__" +
                                                "washing" +
                                                "__" +
                                                type.name
                                            ]
                                          ? "rgb(76, 160, 76)"
                                          : "blue",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            forecast.washed[type.name] !== null
                                              ? forecast.washed[type.name]
                                              : _vm.simulations[
                                                  forecast.date +
                                                    "__" +
                                                    "washing" +
                                                    "__" +
                                                    type.name
                                                ]
                                              ? _vm.simulations[
                                                  forecast.date +
                                                    "__" +
                                                    "washing" +
                                                    "__" +
                                                    type.name
                                                ]
                                              : !_vm.washingDays.includes(
                                                  new Date(
                                                    forecast.date
                                                  ).getDay()
                                                ) ||
                                                !(
                                                  new Date(forecast.date) >
                                                  new Date().setDate(
                                                    new Date().getDate() - 10
                                                  )
                                                )
                                              ? 0
                                              : (
                                                  _vm.crateMeans[
                                                    type.name + "__" + "washing"
                                                  ] +
                                                  _vm.crateMeans[
                                                    type.name +
                                                      "__" +
                                                      "machineWash"
                                                  ]
                                                )?.toFixed(1)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "background-color":
                                      "rgba(190, 230, 250, 1)",
                                    "padding-left": "0.3rem",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(" Repaired "),
                                  _c(
                                    "span",
                                    {
                                      style: forecast.repaired[type.name]
                                        ? {}
                                        : _vm.simulations[
                                            forecast.date +
                                              "__" +
                                              "repair" +
                                              "__" +
                                              type.name
                                          ]
                                        ? { color: "rgb(76, 160, 76)" }
                                        : { color: "blue" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          forecast.repaired[type.name]
                                            ? forecast.repaired[type.name]
                                            : _vm.simulations[
                                                forecast.date +
                                                  "__" +
                                                  "repair" +
                                                  "__" +
                                                  type.name
                                              ]
                                            ? _vm.simulations[
                                                forecast.date +
                                                  "__" +
                                                  "repair" +
                                                  "__" +
                                                  type.name
                                              ]
                                            : !_vm.washingDays.includes(
                                                new Date(forecast.date).getDay()
                                              ) ||
                                              !(
                                                new Date(forecast.date) >
                                                new Date().setDate(
                                                  new Date().getDate() - 10
                                                )
                                              )
                                            ? 0
                                            : _vm.crateMeans[
                                                type.name + "__" + "repair"
                                              ]?.toFixed(1)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    cursor: "pointer",
                                    "border-top":
                                      "1px rgb(190, 190, 190) solid",
                                    "background-color":
                                      "rgba(180, 250, 160, 1)",
                                    "padding-left": "0.3rem",
                                    color: "black",
                                  },
                                  on: {
                                    click: () => {
                                      _vm.collsInDisplayed = true
                                      _vm.checkCollects(
                                        _vm.crateIOs[type.name][index]
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(" In "),
                                  _c(
                                    "span",
                                    {
                                      style:
                                        _vm.crateIOs[type.name][index]
                                          .doneCollsIn.length > 0
                                          ? {}
                                          : _vm.crateIOs[type.name][index].simIn
                                          ? { color: "green" }
                                          : new Date(forecast.date) >
                                            new Date().setDate(
                                              new Date().getDate() + 1
                                            )
                                          ? _vm.crateIOs[type.name][index]
                                              .totalIn >=
                                              _vm.collMeans[type.name] ||
                                            !_vm.washingDays.includes(
                                              new Date(forecast.date).getDay()
                                            )
                                            ? { color: "blue" }
                                            : { color: "brown" }
                                          : _vm.crateIOs[type.name][index]
                                              .predCollsIn.length > 0
                                          ? { color: "blue" }
                                          : {},
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          new Date(forecast.date) >
                                            new Date().setDate(
                                              new Date().getDate() + 1
                                            )
                                            ? _vm.crateIOs[type.name][index]
                                                .totalIn >=
                                                _vm.collMeans[type.name] ||
                                              !_vm.washingDays.includes(
                                                new Date(forecast.date).getDay()
                                              )
                                              ? _vm.crateIOs[type.name][index]
                                                  .totalIn
                                              : _vm.collMeans[
                                                  type.name
                                                ]?.toFixed(1)
                                            : _vm.crateIOs[type.name][index]
                                                .totalIn
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    cursor: "pointer",
                                    "background-color":
                                      "rgba(180, 250, 160, 1)",
                                    "padding-left": "0.3rem",
                                    color: "black",
                                  },
                                  on: {
                                    click: () => {
                                      _vm.collsInDisplayed = false
                                      _vm.checkCollects(
                                        _vm.crateIOs[type.name][index]
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(" Out "),
                                  _c(
                                    "span",
                                    {
                                      style:
                                        _vm.crateIOs[type.name][index]
                                          .doneCollsOut.length > 0
                                          ? {}
                                          : _vm.crateIOs[type.name][index]
                                              .simOut
                                          ? { color: "green" }
                                          : _vm.crateIOs[type.name][index]
                                              .predCollsOut.length > 0
                                          ? { color: "blue" }
                                          : {},
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.crateIOs[type.name][index]
                                            .totalOut
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          )
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "column",
                            style: {
                              color: _vm.holidays.includes(
                                new Date(forecast.date).toLocaleDateString(
                                  "en-CA"
                                )
                              )
                                ? "rgb(255, 255, 255)"
                                : "black",
                            },
                          },
                          [
                            _c("div", { style: { "font-weight": "bold" } }, [
                              _vm._v(" Max "),
                            ]),
                            _c(
                              "table",
                              {
                                style: {
                                  "border-spacing": "1rem 0px",
                                  "border-collapse": "separate",
                                },
                              },
                              [
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s("Total:"))]),
                                  _c("td", [
                                    _vm._v(_vm._s(forecast.total.toFixed(0))),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          (forecast.total /
                                            _vm.target.max_total) *
                                            100 >
                                          80
                                            ? "red"
                                            : "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.target.max_total &&
                                              _vm.target.max_total !== 0
                                              ? (
                                                  (forecast.total /
                                                    _vm.target.max_total) *
                                                  100
                                                ).toFixed(0) + "%"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s("Clean:"))]),
                                  _c("td", [
                                    _vm._v(_vm._s(forecast.clean.toFixed(0))),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          (forecast.clean /
                                            _vm.target.max_clean) *
                                            100 >
                                          80
                                            ? "red"
                                            : "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.target.max_clean &&
                                              _vm.target.max_clean !== 0
                                              ? (
                                                  (forecast.clean /
                                                    _vm.target.max_clean) *
                                                  100
                                                ).toFixed(0) + "%"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c("div", { style: { "font-weight": "bold" } }, [
                              _vm._v(" Safety "),
                            ]),
                            _c(
                              "table",
                              {
                                style: {
                                  "border-spacing": "1rem 0px",
                                  "border-collapse": "separate",
                                },
                              },
                              [
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s("Available:"))]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(forecast.available.toFixed(0))
                                    ),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          (forecast.available /
                                            _vm.target.min_available) *
                                            100 <
                                          100
                                            ? "red"
                                            : "green",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.target.min_available &&
                                              _vm.target.min_available !== 0
                                              ? (
                                                  (forecast.available /
                                                    _vm.target.min_available) *
                                                  100
                                                ).toFixed(0) + "%"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s("Clean:"))]),
                                  _c("td", [
                                    _vm._v(_vm._s(forecast.clean.toFixed(0))),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          (forecast.clean /
                                            _vm.target.min_clean) *
                                            100 <
                                          100
                                            ? "red"
                                            : "green",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.target.min_clean &&
                                              _vm.target.min_clean !== 0
                                              ? (
                                                  (forecast.clean /
                                                    _vm.target.min_clean) *
                                                  100
                                                ).toFixed(0) + "%"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s("Dirty:"))]),
                                  _c("td", [
                                    _vm._v(_vm._s(forecast.dirty.toFixed(0))),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          (forecast.dirty /
                                            _vm.target.min_dirty) *
                                            100 <
                                          100
                                            ? "red"
                                            : "green",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.target.min_dirty &&
                                              _vm.target.min_dirty !== 0
                                              ? (
                                                  (forecast.dirty /
                                                    _vm.target.min_dirty) *
                                                  100
                                                ).toFixed(0) + "%"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("tr", [
                                  _c("td", [_vm._v(_vm._s("Repair:"))]),
                                  _c("td", [
                                    _vm._v(_vm._s(forecast.repair.toFixed(0))),
                                  ]),
                                  _c(
                                    "td",
                                    {
                                      style: {
                                        color:
                                          (forecast.repair /
                                            _vm.target.min_repair) *
                                            100 <
                                          100
                                            ? "red"
                                            : "green",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.target.min_repair &&
                                              _vm.target.min_repair !== 0
                                              ? (
                                                  (forecast.repair /
                                                    _vm.target.min_repair) *
                                                  100
                                                ).toFixed(0) + "%"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c("b-button", {
                          staticClass: "left-right mr-2",
                          style: {
                            display: "block",
                            position: "absolute",
                            right: "60px",
                            "margin-top": "-10px",
                            color: "black",
                          },
                          attrs: {
                            type: "is-ghost",
                            "icon-left": "door-closed",
                            disabled: _vm.isLoading,
                          },
                          on: {
                            click: () => {
                              _vm.addHoliday(
                                new Date(forecast.date).toLocaleDateString(
                                  "en-CA"
                                )
                              )
                            },
                          },
                        }),
                        _vm.holidays.includes(
                          new Date(forecast.date).toLocaleDateString("en-CA")
                        )
                          ? _c("b-button", {
                              staticClass: "left-right mr-2",
                              style: {
                                display: "block",
                                position: "absolute",
                                right: "60px",
                                "margin-top": "-10px",
                                color: "red",
                              },
                              attrs: {
                                type: "is-ghost",
                                "icon-left": "x",
                                disabled: _vm.isLoading,
                              },
                              on: {
                                click: () => {
                                  _vm.removeHoliday(
                                    new Date(forecast.date).toLocaleDateString(
                                      "en-CA"
                                    )
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: forecast.comment?.text,
                              active: forecast.comment ? true : false,
                              multilined: "",
                            },
                          },
                          [
                            _c("b-button", {
                              staticClass: "left-right mr-2",
                              style: {
                                display: "block",
                                position: "absolute",
                                right: "30px",
                                "margin-top": "-10px",
                                color: forecast.comment ? "gold" : "gray",
                              },
                              attrs: {
                                type: "is-ghost",
                                "icon-left": forecast.comment
                                  ? "star"
                                  : "comment",
                                disabled: _vm.isLoading,
                              },
                              on: {
                                click: () => {
                                  _vm.editComment(forecast)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c("b-button", {
                          staticClass: "left-right mr-2",
                          style: {
                            display: "block",
                            position: "absolute",
                            right: "0",
                            "margin-top": "-10px",
                          },
                          attrs: {
                            type: "is-ghost",
                            "icon-left": "edit",
                            disabled: _vm.isLoading,
                          },
                          on: {
                            click: () => {
                              _vm.editForecast(forecast)
                            },
                          },
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.shipmentView
                  ? _c(
                      "div",
                      {
                        style: {
                          display: "flex",
                          "flex-direction": "row",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            style: {
                              height: "15rem",
                              "max-height": "15rem",
                              "overflow-y": "scroll",
                              "-ms-overflow-style": "none",
                              scrollbarWidth: "0",
                              width: "45%",
                            },
                          },
                          [
                            _c(
                              "table",
                              {
                                style: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  border: "2px solid rgb(140 140 140)",
                                  width: "100%",
                                  "border-spacing": "0.5rem 0px",
                                  "border-collapse": "collapse",
                                  "text-align": "left",
                                },
                              },
                              [
                                _vm._m(0, true),
                                _c(
                                  "tbody",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "table",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      forecast.dayMoves.doneCollsIn,
                                      function (move) {
                                        return _c(
                                          "tr",
                                          {
                                            key: "donecollsin" + move.id,
                                            style: {
                                              color: move.relic
                                                ? "blue"
                                                : "black",
                                              "font-weight": move.naval
                                                ? "bold"
                                                : "regular",
                                              "background-color":
                                                move.shipType === "COL"
                                                  ? "rgb(162, 200, 215)"
                                                  : "rgb(162, 200, 255)",
                                              "border-top":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-left":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-right":
                                                "solid 1px rgb(220, 220, 220)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.name) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.id) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.shipment) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      parseInt(move.num_crates)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.type) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.status) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      forecast.dayMoves.predCollsIn,
                                      function (move) {
                                        return _c(
                                          "tr",
                                          {
                                            key: "predcollsin" + move.id,
                                            style: {
                                              color: move.relic
                                                ? "blue"
                                                : "black",
                                              "font-weight": move.naval
                                                ? "bold"
                                                : "regular",
                                              "background-color":
                                                move.shipType === "COL"
                                                  ? "rgb(162, 200, 215)"
                                                  : "rgb(162, 200, 255)",
                                              "border-top":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-left":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-right":
                                                "solid 1px rgb(220, 220, 220)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.name) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.id) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.shipment) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      parseInt(move.num_crates)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.type) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.status) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            style: {
                              height: "15rem",
                              "max-height": "15rem",
                              "overflow-y": "scroll",
                              width: "45%",
                            },
                          },
                          [
                            _c(
                              "table",
                              {
                                style: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  border: "2px solid rgb(140 140 140)",
                                  width: "100%",
                                  "border-spacing": "1rem 0px",
                                  "border-collapse": "collapse",
                                  "text-align": "left",
                                },
                              },
                              [
                                _vm._m(1, true),
                                _c(
                                  "tbody",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "table",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      forecast.dayMoves.doneCollsOut,
                                      function (move) {
                                        return _c(
                                          "tr",
                                          {
                                            key: "donecollsout" + move.id,
                                            style: {
                                              color: move.relic
                                                ? "blue"
                                                : "black",
                                              "font-weight": move.naval
                                                ? "bold"
                                                : "regular",
                                              "background-color":
                                                move.shipType === "DEL"
                                                  ? "rgb(146, 208, 80)"
                                                  : "rgb(251, 226, 213)",
                                              "border-top":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-left":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-right":
                                                "solid 1px rgb(220, 220, 220)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.name) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.id) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.shipment) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      parseInt(move.num_crates)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.type) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.status) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._l(
                                      forecast.dayMoves.predCollsOut,
                                      function (move) {
                                        return _c(
                                          "tr",
                                          {
                                            key: "predcollsout" + move.id,
                                            style: {
                                              color: move.relic
                                                ? "blue"
                                                : "black",
                                              "font-weight": move.naval
                                                ? "bold"
                                                : "regular",
                                              "background-color":
                                                move.shipType === "DEL"
                                                  ? "rgb(146, 208, 80)"
                                                  : "rgb(251, 226, 213)",
                                              "border-top":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-left":
                                                "solid 1px rgb(220, 220, 220)",
                                              "border-right":
                                                "solid 1px rgb(220, 220, 220)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                  overflow: "hidden",
                                                  "text-overflow": "ellipsis",
                                                  "white-space": "nowrap",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.name) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "10ch",
                                                  "max-width": "10ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.id) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.shipment) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      parseInt(move.num_crates)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "4ch",
                                                  "max-width": "4ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(move.type) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticStyle: {
                                                  width: "6ch",
                                                  "max-width": "6ch",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(move.status) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          key: "undecided",
          attrs: {
            active: _vm.isCheckingUndecided,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCheckingUndecided = $event
            },
          },
        },
        [
          _vm.isCheckingUndecided
            ? _c("div", { staticStyle: { "margin-left": "-20vw" } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-card",
                    staticStyle: {
                      "min-width": "70vw",
                      width: "fit-content",
                      "min-height": "50vh",
                      height: "fit-content",
                    },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v(" Undated Movements "),
                        _vm.storedName
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "1rem",
                                  "text-overflow": "elipsis",
                                },
                              },
                              [_vm._v(_vm._s(_vm.storedName))]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c("section", { staticClass: "modal-card-body" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-top": "-20px",
                            "margin-bottom": "20px",
                          },
                        },
                        [
                          _vm._v(" View Crates OUT "),
                          _c("b-switch", {
                            staticStyle: { "margin-left": "10px" },
                            model: {
                              value: _vm.collsInDisplayed,
                              callback: function ($$v) {
                                _vm.collsInDisplayed = $$v
                              },
                              expression: "collsInDisplayed",
                            },
                          }),
                          _vm._v(" View Crates IN "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "auto",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " Total: " +
                                  _vm._s(
                                    _vm.collsInDisplayed
                                      ? _vm.totalUndecidedIn
                                      : _vm.totalUndecidedOut
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.collsInDisplayed
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "columns",
                                  staticStyle: {
                                    "background-color": "rgb(255, 255, 255)",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Origin "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" OB "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" RO "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Quantity "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Type "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Status "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Date "),
                                  ]),
                                ]
                              ),
                              _vm._l(
                                _vm.undecidedCollsIn,
                                function (undecidedCollIn) {
                                  return _c(
                                    "div",
                                    {
                                      key: undecidedCollIn.id,
                                      staticClass: "columns",
                                      style: {
                                        color: undecidedCollIn.relic
                                          ? "blue"
                                          : "black",
                                        "font-weight": undecidedCollIn.naval
                                          ? "bold"
                                          : "regular",
                                        "background-color":
                                          "rgb(162, 200, 215)",
                                        "border-top":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-left":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-right":
                                          "solid 1px rgb(220, 220, 220)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label: undecidedCollIn.name,
                                                position: "is-right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "text-wrap": "nowrap",
                                                    width: "18ch",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        undecidedCollIn.name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollIn.id) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollIn.shipment) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(
                                                  undecidedCollIn.num_crates
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollIn.type) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollIn.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                undecidedCollIn.originDate
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      !_vm.collsInDisplayed
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "columns",
                                  staticStyle: {
                                    "background-color": "rgb(255, 255, 255)",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Destination "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" OB "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" RO "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Quantity "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Type "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Status "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Date "),
                                  ]),
                                ]
                              ),
                              _vm._l(
                                _vm.undecidedCollsOut,
                                function (undecidedCollOut) {
                                  return _c(
                                    "div",
                                    {
                                      key: undecidedCollOut.id,
                                      staticClass: "columns",
                                      style: {
                                        color: "black",
                                        "font-weight": "regular",
                                        "background-color":
                                          undecidedCollOut.shipType === "DEL"
                                            ? "rgb(146, 208, 80)"
                                            : "rgb(251, 226, 213)",
                                        "border-top":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-left":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-right":
                                          "solid 1px rgb(220, 220, 220)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label: undecidedCollOut.name,
                                                position: "is-right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "text-wrap": "nowrap",
                                                    width: "18ch",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        undecidedCollOut.name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollOut.id) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                undecidedCollOut.shipment
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(
                                                  undecidedCollOut.num_crates
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollOut.type) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(undecidedCollOut.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                undecidedCollOut.originDate
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isImportingExcel,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isImportingExcel = $event
            },
          },
        },
        [
          _vm.isImportingExcel
            ? _c("div", { staticStyle: { "margin-left": "-20vw" } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-card",
                    staticStyle: {
                      "min-width": "70vw",
                      width: "fit-content",
                      "min-height": "50vh",
                      height: "fit-content",
                    },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v(" Import Excel Simulations "),
                        _vm.storedName
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "1rem",
                                  "text-overflow": "elipsis",
                                },
                              },
                              [_vm._v(_vm._s(_vm.storedName))]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "section",
                      { staticClass: "modal-card-body" },
                      [
                        _c(
                          "b-field",
                          { attrs: { grouped: "" } },
                          [
                            _c(
                              "b-field",
                              [
                                _c("input", {
                                  attrs: {
                                    id: "fileUpload",
                                    type: "file",
                                    accept:
                                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    hidden: "",
                                  },
                                  on: { change: _vm.loadFile },
                                }),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn",
                                    on: { click: _vm.chooseFiles },
                                  },
                                  [_vm._v(" Choose File ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-field",
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "left-right",
                                    attrs: {
                                      type: "is-warning",
                                      "icon-left": "x",
                                      disabled: !_vm.loadedExcel,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.testExcel()
                                      },
                                    },
                                  },
                                  [_vm._v(" Read Simulations ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.days && _vm.days.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "5px",
                                  "margin-bottom": "20px",
                                },
                              },
                              _vm._l(_vm.days, function (day, index) {
                                return _c(
                                  "div",
                                  { key: "simulation" + index },
                                  [
                                    _c(
                                      "b-field",
                                      {
                                        staticStyle: {
                                          "background-color": "white",
                                          padding: "5px",
                                          width: "fit-content",
                                        },
                                        attrs: { grouped: "" },
                                      },
                                      [
                                        _c("b-field", [
                                          _vm._v(
                                            _vm._s(
                                              new Date(
                                                day.date
                                              ).toLocaleDateString("en-CA")
                                            )
                                          ),
                                        ]),
                                        _c("b-field", [
                                          _vm._v(_vm._s(day.type)),
                                        ]),
                                        _c("b-field", [
                                          _vm._v(_vm._s(day.operation)),
                                        ]),
                                        _c("b-field", [
                                          _vm._v(_vm._s(day.num_crates)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.newFalseShipments &&
                        _vm.newFalseShipments.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "5px",
                                  "margin-bottom": "20px",
                                },
                              },
                              _vm._l(
                                _vm.newFalseShipments,
                                function (newFalseShipment, index) {
                                  return _c(
                                    "div",
                                    { key: "simulation" + index },
                                    [
                                      _c(
                                        "b-field",
                                        {
                                          staticStyle: {
                                            "background-color": "white",
                                            padding: "5px",
                                            width: "fit-content",
                                          },
                                          attrs: { grouped: "" },
                                        },
                                        [
                                          _c("b-field", [
                                            _vm._v(
                                              _vm._s(
                                                new Date(
                                                  newFalseShipment.date
                                                ).toLocaleDateString("en-CA")
                                              )
                                            ),
                                          ]),
                                          _c("b-field", [
                                            _vm._v(
                                              _vm._s(newFalseShipment.name)
                                            ),
                                          ]),
                                          _c("b-field", [
                                            _vm._v(
                                              _vm._s(newFalseShipment.qty)
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _c(
                          "b-field",
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "left-right",
                                attrs: {
                                  type: "is-warning",
                                  "icon-left": "x",
                                  disabled:
                                    _vm.days.length <= 0 &&
                                    _vm.newFalseShipments.length <= 0,
                                },
                                on: {
                                  click: () => {
                                    _vm.saveSimulations()
                                  },
                                },
                              },
                              [_vm._v(" Save Simulations ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          key: _vm.colModalKey,
          attrs: {
            active: _vm.isCheckingColls,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCheckingColls = $event
            },
          },
        },
        [
          _vm.isCheckingColls
            ? _c("div", { staticStyle: { "margin-left": "-20vw" } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-card",
                    staticStyle: {
                      "min-width": "70vw",
                      width: "fit-content",
                      "min-height": "50vh",
                      height: "fit-content",
                    },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _c("p", { staticClass: "modal-card-title" }, [
                        _vm._v(" Movements "),
                        _vm.storedName
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "1rem",
                                  "text-overflow": "elipsis",
                                },
                              },
                              [_vm._v(_vm._s(_vm.storedName))]
                            )
                          : _vm._e(),
                        _vm.displayedColls.collDate
                          ? _c(
                              "span",
                              {
                                staticClass: "ml-3",
                                staticStyle: {
                                  "font-size": "1rem",
                                  "text-overflow": "elipsis",
                                },
                              },
                              [_vm._v(_vm._s(_vm.displayedColls.collDate))]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _c("section", { staticClass: "modal-card-body" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-top": "-20px",
                            "margin-bottom": "20px",
                          },
                        },
                        [
                          _vm._v(" View Crates OUT "),
                          _c("b-switch", {
                            staticStyle: { "margin-left": "10px" },
                            model: {
                              value: _vm.collsInDisplayed,
                              callback: function ($$v) {
                                _vm.collsInDisplayed = $$v
                              },
                              expression: "collsInDisplayed",
                            },
                          }),
                          _vm._v(" View Crates IN "),
                        ],
                        1
                      ),
                      _vm.collsInDisplayed
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "columns",
                                  staticStyle: {
                                    "background-color": "rgb(255, 255, 255)",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Origin "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" OB "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" RO "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Quantity "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Type "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Status "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Date "),
                                  ]),
                                ]
                              ),
                              _vm._l(
                                _vm.displayedColls.doneCollsIn,
                                function (doneCollIn) {
                                  return _c(
                                    "div",
                                    {
                                      key: doneCollIn.id,
                                      staticClass: "columns",
                                      style: {
                                        color: doneCollIn.relic
                                          ? "blue"
                                          : "black",
                                        "font-weight": doneCollIn.naval
                                          ? "bold"
                                          : "regular",
                                        "background-color":
                                          "rgb(162, 200, 215)",
                                        "border-top":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-left":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-right":
                                          "solid 1px rgb(220, 220, 220)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label: doneCollIn.name,
                                                position: "is-right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "text-wrap": "nowrap",
                                                    width: "18ch",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(doneCollIn.name) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(doneCollIn.id) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(doneCollIn.shipment) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(doneCollIn.num_crates)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(doneCollIn.type) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(doneCollIn.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(doneCollIn.done_date) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._l(
                                _vm.displayedColls.predCollsIn,
                                function (predCollIn) {
                                  return _c(
                                    "div",
                                    {
                                      key: predCollIn.id,
                                      staticClass: "columns",
                                      style: {
                                        color: predCollIn.relic
                                          ? "blue"
                                          : "black",
                                        "font-weight": predCollIn.naval
                                          ? "bold"
                                          : "regular",
                                        "background-color":
                                          "rgb(162, 200, 215)",
                                        "border-top":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-left":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-right":
                                          "solid 1px rgb(220, 220, 220)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label: predCollIn.name,
                                                position: "is-right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "text-wrap": "nowrap",
                                                    width: "18ch",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(predCollIn.name) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(predCollIn.id) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(predCollIn.shipment) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(predCollIn.num_crates)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(predCollIn.type) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(predCollIn.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(predCollIn.originDate) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      !_vm.collsInDisplayed
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "columns",
                                  staticStyle: {
                                    "background-color": "rgb(255, 255, 255)",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Destination "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" OB "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" RO "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Quantity "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Type "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Status "),
                                  ]),
                                  _c("div", { staticClass: "column" }, [
                                    _vm._v(" Date "),
                                  ]),
                                ]
                              ),
                              _vm._l(
                                _vm.displayedColls.doneCollsOut,
                                function (doneCollOut) {
                                  return _c(
                                    "div",
                                    {
                                      key: doneCollOut.id,
                                      staticClass: "columns",
                                      style: {
                                        color: doneCollOut.relic
                                          ? "blue"
                                          : "black",
                                        "font-weight": doneCollOut.naval
                                          ? "bold"
                                          : "regular",
                                        "background-color":
                                          doneCollOut.shipType === "DEL"
                                            ? "rgb(146, 208, 80)"
                                            : "rgb(251, 226, 213)",
                                        "border-top":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-left":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-right":
                                          "solid 1px rgb(220, 220, 220)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label: doneCollOut.name,
                                                position: "is-right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "text-wrap": "nowrap",
                                                    width: "18ch",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(doneCollOut.name) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(doneCollOut.id) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(doneCollOut.shipment) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(doneCollOut.num_crates)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(doneCollOut.type) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(doneCollOut.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(doneCollOut.done_date) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._l(
                                _vm.displayedColls.predCollsOut,
                                function (predCollOut) {
                                  return _c(
                                    "div",
                                    {
                                      key: predCollOut.id,
                                      staticClass: "columns",
                                      style: {
                                        color: predCollOut.relic
                                          ? "blue"
                                          : "black",
                                        "font-weight": predCollOut.naval
                                          ? "bold"
                                          : "regular",
                                        "background-color":
                                          predCollOut.shipType === "DEL"
                                            ? "rgb(146, 208, 80)"
                                            : "rgb(251, 226, 213)",
                                        "border-top":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-left":
                                          "solid 1px rgb(220, 220, 220)",
                                        "border-right":
                                          "solid 1px rgb(220, 220, 220)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _c(
                                            "b-tooltip",
                                            {
                                              attrs: {
                                                label: predCollOut.name,
                                                position: "is-right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "text-wrap": "nowrap",
                                                    width: "18ch",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(predCollOut.name) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(predCollOut.id) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(predCollOut.shipment) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(predCollOut.num_crates)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " + _vm._s(predCollOut.type) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(predCollOut.status) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(predCollOut.originDate) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.displayedFalseShipments &&
                      _vm.displayedFalseShipments.length > 0
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "columns mt-4",
                                  staticStyle: { "background-color": "white" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "shipping-detail" },
                                    [_vm._v(" Name ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "shipping-detail" },
                                    [_vm._v(" Quantity ")]
                                  ),
                                ]
                              ),
                              _vm._l(
                                _vm.displayedFalseShipments,
                                function (ship, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index + "-displayedships",
                                      staticClass: "columns",
                                      style: {
                                        "background-color": "gainsboro",
                                        "border-top":
                                          "solid 1px rgb(255, 255, 255)",
                                        "border-left":
                                          "solid 1px rgb(255, 255, 255)",
                                        "border-right":
                                          "solid 1px rgb(255, 255, 255)",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [_vm._v(" " + _vm._s(ship.name) + " ")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "shipping-detail" },
                                        [_vm._v(" " + _vm._s(ship.qty) + " ")]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          key: "commentModal",
          attrs: {
            active: _vm.isEditingComment,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingComment = $event
            },
          },
        },
        [
          _vm.isEditingComment
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitComment(false)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit Comment "),
                          _vm.storedName
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.storedName))]
                              )
                            : _vm._e(),
                          _vm.editableComment.date
                            ? _c(
                                "span",
                                {
                                  staticClass: "ml-3",
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.editableComment.date))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { label: "Comment" } },
                            [
                              _c("b-input", {
                                attrs: { type: "textarea" },
                                model: {
                                  value: _vm.bufferText,
                                  callback: function ($$v) {
                                    _vm.bufferText = $$v
                                  },
                                  expression: "bufferText",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "left-right",
                              attrs: { type: "is-danger", "icon-left": "box" },
                              on: {
                                click: () => {
                                  _vm.submitComment(true)
                                },
                              },
                            },
                            [_vm._v(" Delete ")]
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          key: _vm.modalKey,
          attrs: {
            active: _vm.isEditingForecast,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingForecast = $event
            },
          },
        },
        [
          _vm.isEditingForecast
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit performance forecast "),
                          _vm.storedName
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.storedName))]
                              )
                            : _vm._e(),
                          _vm.editableForecast.date
                            ? _c(
                                "span",
                                {
                                  staticClass: "ml-3",
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.editableForecast.date))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Start Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      name: "editDateStart",
                                      "first-day-of-week": 1,
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                      placeholder: "Start Date",
                                    },
                                    model: {
                                      value: _vm.editDateStart,
                                      callback: function ($$v) {
                                        _vm.editDateStart = $$v
                                      },
                                      expression: "editDateStart",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.editBatch
                                ? _c(
                                    "b-field",
                                    { attrs: { label: "End Date" } },
                                    [
                                      _c("b-datepicker", {
                                        attrs: {
                                          name: "editDateEnd",
                                          "first-day-of-week": 1,
                                          locale: "en-CA",
                                          icon: "calendar-alt",
                                          placeholder: "End Date",
                                        },
                                        model: {
                                          value: _vm.editDateEnd,
                                          callback: function ($$v) {
                                            _vm.editDateEnd = $$v
                                          },
                                          expression: "editDateEnd",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-field",
                                { attrs: { label: "Multiple Days?" } },
                                [
                                  _c("b-checkbox", {
                                    attrs: { name: "batchEdit" },
                                    model: {
                                      value: _vm.editBatch,
                                      callback: function ($$v) {
                                        _vm.editBatch = $$v
                                      },
                                      expression: "editBatch",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "columns" },
                            _vm._l(_vm.editableForecast.types, function (type) {
                              return _c(
                                "div",
                                { key: type, staticClass: "column" },
                                [
                                  _c("div", [_vm._v(_vm._s(type))]),
                                  _vm._l(
                                    _vm.editableForecast.statuses,
                                    function (status) {
                                      return _c("div", { key: status }, [
                                        _vm._v(" " + _vm._s(status) + " "),
                                        _c(
                                          "span",
                                          {
                                            style: _vm.editableForecast.values[
                                              type
                                            ][status].changed
                                              ? { color: "blue" }
                                              : {},
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.editableForecast.values[
                                                    type
                                                  ][status].num_crates
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    }
                                  ),
                                  _c(
                                    "b-field",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        label: "Washed",
                                        "label-position": "on-border",
                                      },
                                    },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          disabled:
                                            _vm.editableWashed[type] === null,
                                          type: "number",
                                          step: "0.1",
                                        },
                                        model: {
                                          value: _vm.editableWashed[type],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editableWashed,
                                              type,
                                              $$v
                                            )
                                          },
                                          expression: "editableWashed[type]",
                                        },
                                      }),
                                      _c("b-button", {
                                        staticClass: "is-small",
                                        attrs: {
                                          "icon-left": "circle-xmark",
                                          type: "is-warning",
                                        },
                                        on: {
                                          click: () => {
                                            _vm.editableWashed[type] = null
                                            _vm.modalKey += 1
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-field",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        label: "Repaired",
                                        "label-position": "on-border",
                                      },
                                    },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          disabled:
                                            _vm.editableRepaired[type] === null,
                                          type: "number",
                                          step: "0.1",
                                        },
                                        model: {
                                          value: _vm.editableRepaired[type],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editableRepaired,
                                              type,
                                              $$v
                                            )
                                          },
                                          expression: "editableRepaired[type]",
                                        },
                                      }),
                                      _c("b-button", {
                                        staticClass: "is-small",
                                        attrs: {
                                          "icon-left": "circle-xmark",
                                          type: "is-warning",
                                        },
                                        on: {
                                          click: () => {
                                            _vm.editableRepaired[type] = null
                                            _vm.modalKey += 1
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-field",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        label: "In",
                                        "label-position": "on-border",
                                      },
                                    },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          disabled:
                                            _vm.editableIn[type] === null,
                                          type: "number",
                                          step: "0.1",
                                        },
                                        model: {
                                          value: _vm.editableIn[type],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editableIn, type, $$v)
                                          },
                                          expression: "editableIn[type]",
                                        },
                                      }),
                                      _c("b-button", {
                                        staticClass: "is-small",
                                        attrs: {
                                          "icon-left": "circle-xmark",
                                          type: "is-warning",
                                        },
                                        on: {
                                          click: () => {
                                            _vm.editableIn[type] = null
                                            _vm.modalKey += 1
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-field",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        label: "Out",
                                        "label-position": "on-border",
                                      },
                                    },
                                    [
                                      _c("b-input", {
                                        attrs: {
                                          disabled:
                                            _vm.editableOut[type] === null,
                                          type: "number",
                                          step: "0.1",
                                        },
                                        model: {
                                          value: _vm.editableOut[type],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editableOut, type, $$v)
                                          },
                                          expression: "editableOut[type]",
                                        },
                                      }),
                                      _c("b-button", {
                                        staticClass: "is-small",
                                        attrs: {
                                          "icon-left": "circle-xmark",
                                          type: "is-warning",
                                        },
                                        on: {
                                          click: () => {
                                            _vm.editableOut[type] = null
                                            _vm.modalKey += 1
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "thead",
      {
        staticStyle: {
          position: "sticky",
          top: "0",
          "background-color": "lightgray",
          display: "table",
          width: "100%",
        },
      },
      [
        _c("tr", [
          _c(
            "td",
            {
              staticStyle: {
                width: "10ch",
                "max-width": "10ch",
                overflow: "hidden",
                "white-space": "nowrap",
              },
            },
            [_vm._v(" Origin ")]
          ),
          _c("td", { staticStyle: { width: "10ch", "max-width": "10ch" } }, [
            _vm._v(" OB "),
          ]),
          _c("td", { staticStyle: { width: "6ch", "max-width": "6ch" } }, [
            _vm._v(" RO "),
          ]),
          _c("td", { staticStyle: { width: "4ch", "max-width": "4ch" } }, [
            _vm._v(" Nbr "),
          ]),
          _c("td", { staticStyle: { width: "4ch", "max-width": "4ch" } }, [
            _vm._v(" Type "),
          ]),
          _c("td", { staticStyle: { width: "6ch", "max-width": "6ch" } }, [
            _vm._v(" Status "),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "thead",
      {
        staticStyle: {
          position: "sticky",
          top: "0",
          "background-color": "lightgray",
          display: "table",
          width: "100%",
        },
      },
      [
        _c("tr", [
          _c(
            "td",
            {
              staticStyle: {
                width: "10ch",
                "max-width": "10ch",
                overflow: "hidden",
                "white-space": "nowrap",
              },
            },
            [_vm._v(" Destination ")]
          ),
          _c("td", { staticStyle: { width: "10ch", "max-width": "10ch" } }, [
            _vm._v(" OB "),
          ]),
          _c("td", { staticStyle: { width: "6ch", "max-width": "6ch" } }, [
            _vm._v(" RO "),
          ]),
          _c("td", { staticStyle: { width: "4ch", "max-width": "4ch" } }, [
            _vm._v(" Nbr "),
          ]),
          _c("td", { staticStyle: { width: "4ch", "max-width": "4ch" } }, [
            _vm._v(" Type "),
          ]),
          _c("td", { staticStyle: { width: "6ch", "max-width": "6ch" } }, [
            _vm._v(" Status "),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }